import {
    DUPLICATE_PRODUCT_FAILURE,
    DUPLICATE_PRODUCT_REQUEST,
    DUPLICATE_PRODUCT_SUCCESS,
    FIND_PRODUCTS_FAILURE,
    FIND_PRODUCTS_REQUEST,
    FIND_PRODUCTS_SUCCESS,
    LOAD_BRANDS_FAILURE,
    LOAD_BRANDS_REQUEST,
    LOAD_BRANDS_SUCCESS,
    LOAD_COUNTRIES_FAILURE,
    LOAD_COUNTRIES_REQUEST,
    LOAD_COUNTRIES_SUCCESS,
    LOAD_DIMENSIONS_FAILURE,
    LOAD_DIMENSIONS_REQUEST,
    LOAD_DIMENSIONS_SUCCESS,
    LOAD_PRODUCT_GROUPS_FAILURE,
    LOAD_PRODUCT_GROUPS_REQUEST,
    LOAD_PRODUCT_GROUPS_SUCCESS,
    LOAD_PRODUCT_CATEGORIES_FAILURE,
    LOAD_PRODUCT_CATEGORIES_REQUEST,
    LOAD_PRODUCT_CATEGORIES_SUCCESS,
    LOAD_SUPPLIERS_FAILURE,
    LOAD_SUPPLIERS_REQUEST,
    LOAD_SUPPLIERS_SUCCESS,
    LOAD_WAREHOUSES_FAILURE,
    LOAD_WAREHOUSES_REQUEST,
    LOAD_WAREHOUSES_SUCCESS,
    RESET_SEARCH,
    UPDATE_PRODUCT_FAILURE,
    UPDATE_PRODUCT_REQUEST,
    UPDATE_PRODUCT_SUCCESS
} from "./actions";

const initialState = {
    isLoading: false,
    errors: [],
    dimensions: {},
    productGroups: [],
    productCategories: [],
    products: [],
    suppliers: [],
    countries: [],
    brands: [],
    warehouses: [],
};

// -----------------------------------------------------------------------------
// REDUCER

export default (state = initialState, action) => {
    switch (action.type) {

        case RESET_SEARCH:

            return initialState;

        case LOAD_DIMENSIONS_SUCCESS:
            return {
                ...state,
                dimensions: action.dimensions,
                isLoading: false,
            };

        case LOAD_DIMENSIONS_REQUEST:
        case LOAD_PRODUCT_GROUPS_REQUEST:
        case LOAD_PRODUCT_CATEGORIES_REQUEST:
        case FIND_PRODUCTS_REQUEST:
        case DUPLICATE_PRODUCT_REQUEST:
        case UPDATE_PRODUCT_REQUEST:
        case LOAD_SUPPLIERS_REQUEST:
        case LOAD_COUNTRIES_REQUEST:
        case LOAD_BRANDS_REQUEST:
        case LOAD_WAREHOUSES_REQUEST:

            return {
                ...state,
                errors: [],
                isLoading: true,
            };

        case LOAD_DIMENSIONS_FAILURE:
        case LOAD_PRODUCT_GROUPS_FAILURE:
        case LOAD_PRODUCT_CATEGORIES_FAILURE:
        case FIND_PRODUCTS_FAILURE:
        case DUPLICATE_PRODUCT_FAILURE:
        case UPDATE_PRODUCT_FAILURE:
        case LOAD_SUPPLIERS_FAILURE:
        case LOAD_COUNTRIES_FAILURE:
        case LOAD_BRANDS_FAILURE:
        case LOAD_WAREHOUSES_FAILURE:

            return {
                ...state,
                errors: action.errors,
                isLoading: false,
            };

        case LOAD_PRODUCT_GROUPS_SUCCESS:
            return {
                ...state,
                productGroups: action.productGroups,
                isLoading: false,
            };

        case LOAD_PRODUCT_CATEGORIES_SUCCESS:
            return {
                ...state,
                productCategories: action.productCategories,
                isLoading: false,
            };

        case FIND_PRODUCTS_SUCCESS:
            return {
                ...state,
                products: action.products,
                isLoading: false,
            };
        case UPDATE_PRODUCT_SUCCESS:
        case DUPLICATE_PRODUCT_SUCCESS:

            return {
                ...state,
                products: [],
                isLoading: false
            };

        case LOAD_SUPPLIERS_SUCCESS:

            return {
                ...state,
                suppliers: action.suppliers,
                isLoading: false
            };

        case LOAD_COUNTRIES_SUCCESS:
            return {
                ...state,
                countries: action.countries,
                isLoading: false
            };

        case LOAD_BRANDS_SUCCESS:
            return {
                ...state,
                brands: action.brands,
                isLoading: false
            };

        case LOAD_WAREHOUSES_SUCCESS:
            return {
                ...state,
                warehouses: action.warehouses,
                isLoading: false
            };


        default:
            return state;
    }
}

// -----------------------------------------------------------------------------
// PRIVATE SELECTORS

export function isLoading(store) {
    return store.isLoading;
}

export function getDimensions(store) {
    return store.dimensions;
}

export function getProductGroups(store) {
    return store.productGroups;
}

export function getProductCategories(store) {
    return store.productCategories;
}

export function getProducts(store) {
    return store.products;
}

export function getSuppliers(store) {
    return store.suppliers;
}

export function getCountries(store) {
    return store.countries;
}

export function getBrands(store) {
    return store.brands;
}

export function getErrors(store) {
    return store.errors;
}

export function getWarehouses(store) {
    return store.warehouses;
}



// WEBPACK FOOTER //
// ./src/scenes/Tools/reducer/index.js